var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.923 7.41a.57.57 0 0 1 0-.816l4.125-3.938a.562.562 0 0 1 .776.813L3.716 6.44h7.972c.311 0 .562.25.562.563 0 .311-.25.562-.562.562H3.715l3.11 2.967a.562.562 0 0 1-.775.814L1.926 7.407z"
  })));
};
export default SvgArrowLeft;